<template>
  <div>
    <div style="height: 40px">
      专利导入模板：<el-link type="primary" @click="downloadTemp"
        >下载模板</el-link
      >
    </div>
    <div style="height: 40px">
      <el-select v-model="uploadParams.patentClass" placeholder="选择所属分类">
        <el-option-group label="家用电力器具">
          <el-option label="家用制冷电器器具" value="101"></el-option>
          <el-option label="家用空气调节器具" value="102"></el-option>
          <el-option label="家用通风电器器具" value="103"></el-option>
          <el-option label="家用厨房电器器具" value="104"></el-option>
          <el-option label="家用清洁卫生电器器具" value="105"></el-option>
          <el-option label="家用美容、保健护理电器器具" value="106"></el-option>
          <el-option label="家用电热电力器具" value="107"></el-option>
          <el-option label="家用声像电力器具" value="108"></el-option>
          <el-option label="家用电力器具专用配件" value="109"></el-option>
          <el-option label="其他家用电力器具" value="110"></el-option>
        </el-option-group>
        <el-option-group label="其他家用器具">
          <el-option label="照明灯具" value="120"></el-option>
          <el-option label="灯用电器附件及其他照明" value="130"></el-option>
        </el-option-group>
      </el-select>
    </div>
    <el-upload
      ref="upload"
      list-type="text"
      :multiple="false"
      :limit="1"
      :action="uploadUrl"
      :before-upload="beforeFileUpload"
      :on-remove="handleRemove"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :auto-upload="false"
      :headers="imgHeaders"
      :data="uploadParams"
      name="fileList"
      accept=".xlsx"
    >
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <div slot="tip" class="el-upload__tip">
        只能上传excel文件，且不超过30Mb
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  data () {
    return {
      fileList: [],
      imgHeaders: {
        'X-Authorization-With': localStorage.getItem('token')
      },
      uploadUrl: this.COMMON_CONFIG.HTTP_API_CTX + 'file/patent/input/list',
      uploadParams: {
        mtype: 10,
        patentClass: ''
      }
    };
  },
  created () {
    this.fileList = [];
  },
  methods: {
    downloadTemp () {
      this.$http(
        {
          method: 'get',
          url: 'file/load/patent/template',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }).then(response => {
          this.download(response);
        }).catch((error) => {
          this.$message.error(error);
        }
        );
    },
    download (data) {
      if (data.status == 204) {
        this.$message.error("文件不存在.");
        return;
      }

      let fileName = "外文专利导入模板.xlsx";

      let url = window.URL.createObjectURL(new Blob([data.data]));
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    handleRemove () { },
    submitUpload () {
      if (this.uploadParams.patentClass === '') {
        this.$message.error('请选择分类');
        return;
      }
      this.$refs.upload.submit();
    },
    uploadSuccess (response) {
      // console.log(response);
      if (response.code == 0) {
        this.$emit('uploadOk')
        this.$message.success(response.data);
      } else {
        this.$message.error(response.msg);
      }
    },
    uploadError (err) {
      this.$message.error(err);
    },
    beforeFileUpload (file) {
      const isLtM = file.size / 1024 / 1024 < 30;
      if (!isLtM) {
        this.$message.error('上传文件不能超过30MB!');
      }

      return isLtM;
    }
  },
};
</script>

<style>
.el-upload--text {
  background-color: #fff;
  border: 0px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 85px;
  height: 40px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
</style>